/* eslint semi: 1 */

/**
 * Standartized response from a child form
 * @param {*} hasError - boolean, has form error or no
 * @param {*} nextPage - redirect to the next page or no
 * @param {*} payload  - provide any additional data
 * @returns
 */
export const PageResponse = (hasError, nextPage, data) => {
  return { hasError, nextPage, data };
};

/**
 * This is example of an Either Monad which is
 * very useful when you deal with error handling
 * when working with form validation.
 */
export const proxyException = async (fn) => {
  try {
    return EitherResponse(await fn());
  } catch (e) {
    return EitherResponse(null, e);
  }
};

/**
 * This is shortcut to build object { ok: okResult, error: errorResult }
 */
export const EitherResponse = (successResponse, errorResponse) => {
  return { ok: successResponse || null, error: errorResponse || null };
};

/**
 * This is to get error message from response.
 * If message is not available from response, then return the default message
 */
export const ErrorMessageFromResponse = (error, defaultMessage) => {
  return error.response?.data ? error.response.data.message ?? defaultMessage : defaultMessage;
};
